module.exports = __webpack_public_path__ + "img/modular_settlement_submit@2x.08e4363c.png";